import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as registrationActions from '../../../actions/registration';

class Guidance extends React.Component {
  componentDidMount() {
    this.props._registration.updateProperty('access_code', 'Engage2');
  }

  render() {
    return <div className="columns">
      <div className="column"></div>
      <div className="column content">
        Enhance your treatment plan with your current care provider.<br/>
        Becoming an active agent in your care by using this free access code:
      </div>
      <div className="column"></div>
    </div>;
  }
}

function mapStateToProps(state) {
  return {
    registration: state.registration
  };
}

function mapDispatchToProps(dispatch) {
  return {
    _registration: bindActionCreators(registrationActions, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Guidance);



// WEBPACK FOOTER //
// ./src/components/pages/landing/Guidance.js